export interface FooterLink {
  label: string;
  href: string;
}

export interface FooterSection {
  title: string;
  links: FooterLink[];
}

export interface SocialLink {
  label: string;
  href: string;
  icon: string; // Iconify icon name, e.g., "mdi:instagram"
}

export const footerSections: FooterSection[] = [
  {
    title: "Ecole de tennis",
    links: [
      { label: "Groupes enfants", href: "/ecole-de-tennis/groupes-enfants" },
      { label: "Groupes adultes", href: "/ecole-de-tennis/groupes-adultes" },
      { label: "Enseignants", href: "/ecole-de-tennis/enseignants" },
      { label: "Partenaires", href: "/partenaires" },
    ],
  },
  {
    title: "TCAB",
    links: [
      { label: "Tarifs", href: "/#tarifs" },
      { label: "Articles", href: "/articles" },
      { label: "Actualités", href: "/actualites-tennis" },
      { label: "Contact", href: "/#contact" },
    ],
  },
  {
    title: "Fête le mur",
    links: [
      { label: "Lieux", href: "/fete-le-mur" },
      { label: "Référents", href: "/fete-le-mur/referents" },
    ],
  },
  {
    title: "Liens utiles",
    links: [
      { label: "CGV", href: "/cgv" },
      { label: "Mentions légales", href: "/mentions-legales" },
      { label: "Gestion des cookies", href: "/cookies" },
    ],
  },
];

export const socialLinks: SocialLink[] = [
  {
    label: "Instagram",
    href: "https://taap.it/rhCyIy",
    icon: "mdi:instagram",
  },
  {
    label: "Facebook",
    href: "https://taap.it/brOauU",
    icon: "mdi:facebook",
  },
];
